import React from 'react'
import { InputNumber as AntdInputNumber, InputNumberProps } from 'antd'

const InputNumber = (props: InputNumberProps<number>) => {
  return <AntdInputNumber {...props} decimalSeparator=','/>
};

export default InputNumber;

